import axios from 'axios';

const instance = axios.create({
    // Задаётся при сборке (docker/production/Dockerfile, .env.local для разработки).
    baseURL: process.env.REACT_APP_API_URL || 'https://api.cloverapp.ru/v1/',
});

instance.interceptors.request.use((config) => {
    if (config.headers) {
        config.headers.Authorization = `Bearer ${window.localStorage.getItem('token')}`;
    }
    return config;
});

export default instance;
